import { FaHtml5, FaCss3, FaJs, FaReact, FaPhp } from 'react-icons/fa';
import { SiFirebase, SiMysql, SiThreedotjs, SiTypescript } from "react-icons/si";
import { RiSupabaseLine } from "react-icons/ri";
import { TbBrandNextjs } from "react-icons/tb";
import { SiGreensock } from "react-icons/si";
import { RiOpenaiFill } from "react-icons/ri";
import { RiTailwindCssLine } from "react-icons/ri";
import { SiWondersharefilmora } from "react-icons/si";
import { ReactNode } from 'react';

type SkillIconsType = {
    [key: string]: ReactNode;
};

export const skills_icons: SkillIconsType = {
    "javascript": <FaJs title="JavaScript" />,
    "React": <FaReact title="React" />,
    "openAI": <RiOpenaiFill title="OpenAI" />,
    "three.js": <SiThreedotjs title='Three.js' strokeWidth={1} />,
    "next.js": <TbBrandNextjs title='next.js'/>,
    "php": <FaPhp title="PHP" />,
    "mysql": <SiMysql title='mySQL'/>,
    "supabase": <RiSupabaseLine title='Supabase'/>,
    "firebase": <SiFirebase title='Firebase'/>,
    "gsap": <SiGreensock title="GSAP" strokeWidth={1} />,
    "css": <FaCss3 title="CSS3" />,
    "html": <FaHtml5 title="HTML5" />,
    "tailwind": <RiTailwindCssLine title="Tailwind" />,
    "filmora": <SiWondersharefilmora title="Filmora" />,
    "typescript": <SiTypescript title="TypeScript" />
};